export default __webpack_public_path__ + "static/Home-banner-1x-8f31c67caeb4d229741d7fdd873ebeec.png";